import React, {useEffect, useState} from 'react'
import {mobileActions} from "../../../store/actions";
import {connect} from "react-redux";
import history from "../../../route/history";

const MobileNotification = props => {

    useEffect(() => {
        props.load();
    },[])

    useEffect(() => {
        props.count();
    },[])

    useEffect( () => {
        if(props.isCalled === true && props.isFailure === false) {
            window.location.replace('/mobile/notification')
        }
    }, [props.isCalled])

    const deleteAlarm = () => {
        props.delAll();
    }

    const del = (seq) => {
        props.del(seq);
    }

    return (
        <React.Fragment>
            <div className="content page-notification">
                <div className="inner">

                   <h4 className="tit-lev0">알림</h4>
                    <div className="mobile-notification-table">
                        <div className="inner">
                            {props.alarmCount > 0 ?
                            <div className="scroll">
                            {props.list?.map((push) => (
                                <div className="row">
                                    <div className="mobile-table-inner dis-flex">
                                            <div>
                                                <button className="icon-delete"
                                                        onClick={() => del(push.alarmSeq)}
                                                >삭제</button>
                                            </div>
                                            <div className="m-l-10">
                                                <div className="">{push.title}</div>
                                                <div className="">{push.contents}</div>
                                                <div className="">{push.regDt}</div>
                                            </div>

                                    </div>
                                </div>
                                ))
                            }
                            </div> : <p className="no-data">알림 내용이 없습니다.</p>}
                        </div>
                    </div>
                    <div className="mobile-notification-button">
                                                <button className="btn btn-primary btn-md btn-full" onClick={deleteAlarm}>알림 전체삭제</button>
                                            </div>

                    {props.alarmCount > 0 &&
                        <div className="mobile-notification-button">
                            <button className="btn btn-white btn-md btn-full" onClick={deleteAlarm}>알림 전체삭제</button>
                        </div>
                    }

                </div>
            </div>

        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        list : state.mobile?.data,
        isCalled: state.mobile.isCalled,
        isFailure:state.mobile.isFailure,
        alarmCount: state.mobile.count,
    }
}
const actionCreators = {
    count: mobileActions.count,
    load: mobileActions.load,
    delAll: mobileActions.delAll,
    del: mobileActions.del,

}

export default connect(
    mapStateToProps,
    actionCreators
)(MobileNotification)
